function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#F64B39",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80 27V128"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 43H125"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80 18C74.5 18 71 24 71 30.5C71 37 74.5 43 80 43C85.5 43 89 37 89 30.5C89 24 85.5 18 80 18Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51 44L34 80"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111 44L128 80"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34 80L18 80L35 44L52 80H34Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 80C18 91 25 99 35 99C45 99 52 91 52 80"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128 80H111L128 44L145 80H128Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111 80C111 91 118 99 128 99C138 99 145 91 145 80"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 137C62 128 70 122 80 122C90 122 98 128 98 137"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50 138H110"
}));

function SvgScales(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0412\u0435\u0441\u044B \u043F\u0440\u0430\u0432\u043E\u0441\u0443\u0434\u0438\u044F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScales);
export default __webpack_public_path__ + "static/media/scales.17447e4ba2c3f61ac287b19d5e22ca4f.svg";
export { ForwardRef as ReactComponent };